import { Component, EventEmitter, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { take, takeUntil } from 'rxjs/operators';
import { DeactivationDialogService } from '../../../../helper/can-deactivate/deactivation-dialog.service';
import { FinancialCapexService } from '../../../financial/financial-capex/financial-capex.service';
import { ProjectFinancialService } from '../../../financial/project-financial.service';
import { FinancialCapex } from '../../../../models/project/financial/financial-capex.model';
import { AnessaTranslationService } from '../../../../helper/translation/anessa-translation.service';
import { UserpilotReloader } from '../../../../helper/userpilot-reloader.component';

@Component({
  selector: 'app-add-capex-dialog',
  templateUrl: './add-capex-dialog.component.html',
  styleUrls: [
    './add-capex-dialog.component.scss',
  ]
})
export class AddCapexDialogComponent extends UserpilotReloader implements OnInit, OnDestroy {
  onDestroyNotifier = new EventEmitter();
  /** trigger for translation pipe */
  trigger: string;

  @ViewChild('capexForm') capexForm: NgForm;

  capex: FinancialCapex;

  isEdit = false;

  constructor(
    private dialogRef: MatDialogRef<AddCapexDialogComponent>,
    private dialogService: DeactivationDialogService,
    private financialService: ProjectFinancialService,
    private capexService: FinancialCapexService,
    public translationService: AnessaTranslationService,
    @Inject(MAT_DIALOG_DATA) private data: { isEdit: boolean, capex: FinancialCapex },
  ) {
    super();
    if (this.data) {
      this.isEdit = this.data.isEdit;
      if (this.isEdit) {
        this.capex = this.data.capex;
      } else {
        this.capex = new FinancialCapex();
        this.capex.name = this.translationService.get('PROJECT.FINANCIAL_CAPEX.TOTAL_CAPEX_AMOUNT');
        this.capex.lifetime = this.capexService.getDefaultLifetime();
        const targetCurUnit = this.financialService.getCurrencyUnitById(this.capexService.getTargetUnitForTotalCapex());
        this.capex.cost.unit = targetCurUnit.id;
      }
    }
  }

  ngOnInit() {
    this.translationService.languageChangeNotifier
      .pipe(takeUntil(this.onDestroyNotifier))
      .subscribe(() => {
        this.trigger = this.translationService.getCurrentLang();
      });

    this.dialogRef.backdropClick().subscribe(() => {
      if (this.capexForm && this.capexForm.dirty) {
        this.dialogService.confirm(this.translationService.get('PROJECT.COMMON.DEACTIVATE_CONFIRM'))
          .pipe(take(1)).subscribe((result: boolean) => {
            if (result) {
              this.dialogRef.close();
            }
          });
      } else {
        this.dialogRef.close();
      }
    });
  }

  ngOnDestroy() {
    this.onDestroyNotifier.emit();
    this.onDestroyNotifier.unsubscribe();
  }

  onSaveClick() {
    this.dialogRef.close(this.capex);
  }

  onCancelClick() {
    this.dialogRef.close(null);
  }
}
